import { render, staticRenderFns } from "./PriceBoxBeck.vue?vue&type=template&id=c3030bf8&scoped=true&"
import script from "./PriceBoxBeck.vue?vue&type=script&lang=js&"
export * from "./PriceBoxBeck.vue?vue&type=script&lang=js&"
import style0 from "./PriceBoxBeck.vue?vue&type=style&index=0&id=c3030bf8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3030bf8",
  null
  
)

export default component.exports